import { MerchantUserType } from "@/models/club";
import useSignUp from "@/services/auth/hooks/useSignUp";
import { SignUpVerifyPayload } from "@/services/auth/type";
import { useGetMerchantForMerchantUser } from "@/services/merchant/utilities";
import { useValidateReferralCode } from "@/services/referralCode/hooks/useValidateReferralCode";
import {
  Button,
  Grid,
  Group,
  LoadingOverlay,
  PasswordInput,
  Stack,
  TextInput,
} from "@mantine/core";
import { useForm, yupResolver } from "@mantine/form";
import { notifications } from "@mantine/notifications";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as Yup from "yup";

const signUpSchema = Yup.object({
  firstName: Yup.string().required("وارد کردن نام الزامی است."),
  lastName: Yup.string()
    .nullable()
    .required("وارد کردن نام خانوادگی الزامی است."),
  password: Yup.string()
    .required("پسورد را وارد نمایید")
    .test("length", "رمز عبور باید حداقل 8 کاراکتر باشد.", (value) => {
      console.log(value?.length);
      return value === null || value === "" || value?.length >= 8;
    })
    .matches(
      /^[a-zA-Z0-9!@#$%^&*()_+=-]*$/,
      "لطفا کیبورد خود را به انگلیسی تغییر دهید."
    ),
  referralCode: Yup.string()
    .nullable()
    .matches(
      /^[a-zA-Z0-9!@#$%^&*()_+=-]*$/,
      "لطفا کیبورد خود را به انگلیسی تغییر دهید."
    )
    .test("length", "مقدار کد را به درستی وارد نمایید", (value) => {
      return value === null || value === "" || value?.length === 6;
    }),
});

export default function SignUp() {
  const navigate = useNavigate();
  const location = useLocation();
  const { phoneNumber } = location.state;
  const { data: merchant, isLoading: isLoadingMerchant } =
    useGetMerchantForMerchantUser(phoneNumber);
  const { mutate, isLoading, isSuccess } = useSignUp();
  const [refCode, setRefCode] = useState("");

  const form = useForm<SignUpVerifyPayload>({
    validate: yupResolver(signUpSchema),
    initialValues: {
      firstName: "",
      lastName: "",
      imei: "",
      mobileNumber: phoneNumber,
      password: "",
      referralCode: "",
    },
  });

  useEffect(() => {
    if (isSuccess) {
      notifications.show({
        title: "عملیات موفق",
        message: "کد فعال سازی برای شما ارسال گردید",
        color: "green",
      });

      const imei = localStorage.getItem("imei");

      navigate("/auth/verification", {
        state: {
          firstName: form?.values.firstName,
          lastName: form?.values.lastName,
          imei: imei,
          mobileNumber: phoneNumber,
          password: form?.values?.password,
          isSignUp: true,
          refCode: form?.values?.referralCode,
          merchantUserType: MerchantUserType?.Value0,
        },
      });
    }
  }, [isSuccess, navigate]);

  const { isFetching: checkCodeLoading, isSuccess: isSuccessCheckCode } =
    useValidateReferralCode(refCode);

  useEffect(() => {
    if (isSuccessCheckCode) {
      mutate({
        mobileNumber: phoneNumber,
      });
    }
  }, [isSuccessCheckCode]);

  useEffect(() => {
    const { phoneNumber } = location.state;
    if (merchant) {
      navigate(`/auth/signUpMerchantUser`, {
        state: {
          phoneNumber: phoneNumber,
        },
      });
    }
  }, [merchant, location.state, navigate]);

  const submit = () => {
    const referralCode = form?.values?.referralCode;
    if (referralCode) setRefCode(form?.values?.referralCode || "");
    else {
      mutate({
        mobileNumber: phoneNumber,
      });
    }
  };

  if (!location?.state) {
    navigate("/auth/login");
    return null;
  }

  return (
    <Stack justify="center" mih="400px">
      <LoadingOverlay visible={isLoadingMerchant} />
      {/* <Text>لطفا اطلاعات خود را وارد نمایید</Text> */}
      <form onSubmit={form.onSubmit(submit)}>
        <Grid>
          <Grid.Col span={{ base: 12 }}>
            <TextInput
              styles={{
                description: {
                  fontSize: "0.8rem",
                },
                error: {
                  fontSize: "0.8rem",
                },
              }}
              size="md"
              withAsterisk
              label="نام"
              placeholder=""
              {...form.getInputProps("firstName")}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12 }}>
            <TextInput
              styles={{
                description: {
                  fontSize: "0.8rem",
                },
                error: {
                  fontSize: "0.8rem",
                },
              }}
              size="md"
              withAsterisk
              label="نام خانوادگی"
              placeholder=""
              {...form.getInputProps("lastName")}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12 }}>
            <PasswordInput
              size="md"
              label="کلمه عبور"
              withAsterisk
              styles={{
                label: {
                  direction: "rtl",
                  textAlign: "right",
                  display: "flex",
                },
                root: {
                  direction: "ltr",
                },
                error: {
                  direction: "rtl",
                  fontSize: "0.8rem",
                },
              }}
              {...form.getInputProps("password")}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12 }}>
            <TextInput
              size="md"
              label="کد معرف"
              type="tel"
              maxLength={6}
              styles={{
                input: {
                  direction: "ltr",
                  textAlign: "left",
                },
                description: {
                  fontSize: "0.8rem",
                },
                error: {
                  fontSize: "0.8rem",
                },
              }}
              {...form.getInputProps("referralCode")}
            />
          </Grid.Col>
          <Group my={20} w="100%">
            <Button
              type="submit"
              size="lg"
              loading={isLoading || checkCodeLoading}
              fullWidth
            >
              ثبت نام
            </Button>
          </Group>
        </Grid>
      </form>
    </Stack>
  );
}
